import React, { useEffect } from 'react';
import DocPageHeader from 'components/docs/DocPageHeader';
import ConnectorGroupManagementPanel from './ConnectorGroupManagementPanel';
import useCustomer from 'hooks/useCustomer';
import { useLoading } from 'providers/LoadingProvider'; 

const ConnectorGroupManagementPage: React.FC = () => {
  const {
    connectorGroups,
    connectors,
    createConnectorGroup,
    updateConnectorGroup,
    deleteConnectorGroup,
    monthlySummary,
    weeklySummary
  } = useCustomer();

  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    showLoading(); // شروع لودینگ
    const timeout = setTimeout(() => {
      hideLoading(); // اتمام لودینگ
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      <DocPageHeader title="Connector Groups" />
      <p>Use groups to organize connectors by business unit or client connectorGroup so their collected data stays separated and organized.</p>
      <ConnectorGroupManagementPanel
        connectorGroups={connectorGroups}
        connectors={connectors}
        createConnectorGroup={createConnectorGroup}
        updateConnectorGroup={updateConnectorGroup}
        deleteConnectorGroup={deleteConnectorGroup}
      />
    </div>
  );
};

export default ConnectorGroupManagementPage;
